import React, { Component } from 'react';
import styled from 'styled-components';
import { dark, primary, red, white } from 'react-components/dist/values/colors/colors';
import { secondaryFont } from 'react-components/dist/values/fonts/fonts';

const Wrapper = styled.div`
  width: 100%;
  margin-top: 6px;
`;

const InputText = styled.input`
  border: 0;
  background: none;
  border-bottom: 3px solid;
  border-color: ${props => (props.invalid ? red : props.light ? dark : white)};
  padding: 3px 6px;
  box-sizing: border-box;
  font: ${secondaryFont.large};
  font-size: 1em;
  outline: 0;
  color: ${props => (props.light ? dark : white)};
  width: 100%;
  transition: 0.3s border-color;
  &::placeholder {
    color: ${props => (props.light ? dark : white)}70;
  }
  &:hover {
    cursor: pointer;
  }
  &:focus {
    border-color: ${props => (props.dark ? primary : dark)};
  }
`;

class Input extends Component {
  handleChange = e => {
    this.props.onChange(e.target.value);
  };

  render() {
    return (
      <Wrapper>
        <InputText
          onChange={e => this.handleChange(e)}
          light={this.props.light}
          dark={this.props.dark}
          type={this.props.type}
          placeholder={this.props.placeholder}
          name={this.props.name}
          invalid={this.props.valid}
        />
      </Wrapper>
    );
  }
}

export default Input;
